import React, { useEffect, useRef, useState } from "react";
import { BsCheckCircle, BsCheckCircleFill, BsInfoCircle } from "react-icons/bs";
import {
  Button,
  Col,
  Form,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { ShimmerTitle } from "react-shimmer-effects";
import {
  handleBusinessFileDelete,
  handlePOFFileUpload,
} from "@/components/user/MyBids/Editcif/editcif/fileUploadHandler";
import { useDispatch, useSelector } from "react-redux";
import { setDepositData } from "@/bidFeature/bidSlice";
import { getBidPageDetail } from "@/api/bidDepositApiHold";
import { setBidAmount } from "@/bidFeature/bidwizardSlice";
import { getBidDepositDetail, saveCif, getCifDocuments } from "@/api/bid";
import { useNavigate } from "react-router";
const EditProofOfFunds = ({
  cifId,
  cifData,
  setCollapseAccordian,
  collapseAccordian,
  submittedAccordions,
  setSubmittedAccordions,
  isEnabled,
  editCifUserData,
  listingId,
  pof,
  // listing,
  primaryBuyerData,
  cobuyerData,
  agentData,
  selectedDescription,
  buyingForSelf,
  hasCobuyer,
  primaryEntityType,
  cobuyerEntityType,
  uploadedFiles,
  setUploadedFiles, // Add this prop
  formState,
  isSubmitting,
  setIsSubmitting,
  setCifCompleted,
  commercialPof,
  titleInsuranceForm,
  closingAgentForm,
  selectedClosingOption,
  paymentFlag,
  setIsBidDeposit,
  winningBidUserEmail,
}) => {
  const MAX_FILE_SIZE = 10 * 1024 * 1024;

  const [isUploadingPOF, setIsUploadingPOF] = useState(false);
  const [isDeletingPOF, setIsDeletingPOF] = useState(false);
  const [fileError, setFileError] = useState("");
  // const [uploadedFiles, setUploadedFiles] = useState({
  //   pof: null,
  // });
  const [acknowledgement, setAcknowledgement] = useState(false);
  const [acknowledgementError, setAcknowledgementError] = useState("");
  const [hasCheckboxInteracted, setHasCheckboxInteracted] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cityUser = useSelector((state) => state?.user?.user);

  const closingData = cifData?.data?.closingOptionDetails?.[0] || {};
  const closingDataDetails = cifData?.data?.closingDetail?.closingAgent;
  const titleInsuranceProvider =
    cifData?.data?.closingDetail?.titleInsuranceProvider;

  const {
    isClosingAgentRequired,
    isTitleInsuranceProviderRequired,
    closingOptionType,
    titleInsuranceFeeDetail,
  } = closingData;
  // console.log("gorircity", cityUser);
  // File input reference
  const pofFileInputRef = useRef(null);
  const listing = useSelector(
    (state) => state?.pdp?.pdpInitData?.propertyDetails
  );
  const listing_Price = useSelector(
    (state) => state?.propertyDetail?.getPropertyDetail
  );
  const [isCWCOTProp, setIsCWCOTProp] = useState(
    listing?.commonAttributes?.propCategory === "SC" &&
      listing?.address?.state !== "CA" &&
      listing?.cwcotUpdatesEnabled &&
      listing?.cwcotUpdatesValid
      ? true
      : false
  );

  const [isCWCOTCAProp, setIsCWCOTCAProp] = useState(
    listing?.commonAttributes?.propCategory === "SC" &&
      listing?.address?.state === "CA" &&
      listing?.cwcotUpdatesEnabled &&
      listing?.cwcotUpdatesValid
      ? true
      : false
  );
  const [isCABillProp, setIsCABillProp] = useState(() => {
    // 1. First check exclusion conditions - if these are true, it's definitely not a CA Bill property
    // Log initial values
    console.log("CA Bill Check - Initial Values:", {
      listingType: listing_Price?.listingPriceDetail?.listingType,
      propCategory:
        listing_Price?.propertyDetails?.commonAttributes?.propCategory,
      stateWorkflowDurationActive: listing_Price?.stateWorkflowDurationActive,
      stateWorkflowEnabled: listing_Price?.stateWorkflowEnabled,
      isCWCOTCAProp,
    });
    const isExcluded =
      listing_Price?.listingPriceDetail?.listingType === "TRNL" ||
      listing_Price?.propertyDetails?.commonAttributes?.propCategory ===
      "COMMERCIAL";

    if (isExcluded) {
      return false;
    }

    // 2. Then check if it meets CA Bill requirements
    const isCABillEligible =
      listing_Price?.stateWorkflowDurationActive === true &&
      listing_Price?.stateWorkflowEnabled === true &&
      !isCWCOTCAProp;
    console.log("CA Bill eligibility result:", {
      isCABillEligible,
      stateWorkflowDurationActive: listing_Price?.stateWorkflowDurationActive,
      stateWorkflowEnabled: listing_Price?.stateWorkflowEnabled,
      isCWCOTCAProp,
    });
    return isCABillEligible;
  });
  // Handle acknowledgement change
  // const handleAcknowledgementChange = (e) => {
  //   const isChecked = e.target.checked;
  //   setAcknowledgement(isChecked);
  //   // Update error message based on checkbox state
  //   setAcknowledgementError(
  //     isChecked ? "" : "Please accept the above acknowledgement."
  //   );
  // };
  // Modified acknowledgement handler
  // Modified acknowledgement handler
  const handleAcknowledgementChange = (e) => {
    const isChecked = e.target.checked;
    setAcknowledgement(isChecked);

    // Set interaction flag if not already set
    if (!hasCheckboxInteracted) {
      setHasCheckboxInteracted(true);
    }

    // Only show error message if user has interacted with checkbox
    if (hasCheckboxInteracted) {
      setAcknowledgementError(
        isChecked ? "" : "Please accept the above acknowledgement."
      );
    }
  };

  // useEffect(() => {

  //   const prepopulatePOFDocument = async () => {

  //     try {
  //       const response = await getCifDocuments(cifId); // Use imported JSON

  //       const pofFiles = response?.data?.data?.pofFiles
  //       // Check if we have valid response data
  //       if (response?.data) {

  //         // Handle POF documents
  //         if (pofFiles?.length > 0) {
  //           const pofDoc = pofFiles[0];

  //           setUploadedFiles((prev) => ({
  //             ...prev,
  //             pof: [
  //               ...(prev.pof || []),
  //               {
  //                 documentId: pofDoc?.documentId,
  //                 fileName: pofDoc?.fileName,
  //                 listingId: listingId || pofDoc.listingId,

  //               },
  //             ],
  //           }));
  //         }
  //       } else {
  //         console.log("No valid POF document data in response");
  //       }
  //     } catch (error) {
  //       console.error("Error loading POF document:", error);
  //       setFileError("Error loading existing POF document");
  //     }
  //   };

  //   // Only fetch POF document if we have listingId and jsonResponse
  //   if (cifId) {
  //     prepopulatePOFDocument();
  //   } else {
  //     console.log("Conditions not met for POF document prepopulation");
  //   }
  // }, [cifId]); // Dependencies

  const validateFile = (file) => {
    if (!file) return "Please select a file";
    if (file.size > MAX_FILE_SIZE) return "File size exceeds 10MB limit";
    return "";
  };

  // Modified File Change Handler
  const handlePOFFileChange = async (event) => {
    const file = event.target.files[0];

    if (!file) return;

    const error = validateFile(file);
    if (error) {
      setFileError("Maximum file size allowed is 10MB");
      return;
    }

    setIsUploadingPOF(true);
    setFileError("");

    try {
      if (!listingId) {
        throw new Error("Listing ID is required");
      }

      const result = await handlePOFFileUpload(file, listingId);

      if (result.success) {
        setUploadedFiles((prev) => ({
          ...prev,
          pof: [
            ...(prev.pof || []),
            {
              documentId: result.data.documentId,
              fileName: result.data.fileName,
              listingId: listingId,
            },
          ],
        }));
        setFileError("");
      } else {
        setFileError(result.error);
      }
    } catch (error) {
      console.error("POF upload error:", error);
      setFileError(error.message || "Error uploading file");
    } finally {
      if (pofFileInputRef.current) {
        pofFileInputRef.current.value = "";
      }
      setIsUploadingPOF(false);
    }
  };

  // Modified File Delete Handler
  const handlePOFFileDelete = async (index) => {
    const files = uploadedFiles.pof;
    if (!files?.[index]?.documentId) {
      return;
    }

    setIsDeletingPOF(true);
    setFileError("");

    try {
      const result = await handleBusinessFileDelete(
        files[index].documentId,
        listingId
      );

      if (result.success) {
        setUploadedFiles((prev) => ({
          ...prev,
          pof: prev.pof.filter((_, idx) => idx !== index),
        }));
        setFileError("");
      } else {
        setFileError(result.error);
      }
    } catch (error) {
      setFileError(error.message || "Error deleting file");
    } finally {
      setIsDeletingPOF(false);
    }
  };

  // Modified Submit Handler
  const handlePOFSubmit = async () => {
    setFileError("");
    setAcknowledgementError("");

    if (!acknowledgement) {
      setAcknowledgementError("Please accept the above acknowledgement.");
      return;
    }

    // Check POF document if required
    if (
      pof === "Required" &&
      (!uploadedFiles.pof || uploadedFiles.pof.length === 0) &&
      commercialPof !== "Y"
    ) {
      setFileError(
        "Please upload at least one proof of funds document to proceed."
      );
      return;
    }

    try {
      setIsUploadingPOF(true);
      await handleFinalSubmit();
    } catch (error) {
      console.error("Submit error:", error);
      setFileError(
        "Error submitting POF: " + (error.message || "Unknown error")
      );
    } finally {
      setIsUploadingPOF(false);
    }
  };

  const getBuyerCategory = () => {
    switch (primaryEntityType) {
      case "selfOccupancy":
        return "SELF_OCCUPANCY";

      case "hudNonProfit":
        return "HUD_APPROVED";

      case "government":
        return "GOVT_ENTITY";

      case "caBillOwnerOccupied":
        return "OWNER_OCCUPIED_BUYER";

      case "caBillNonProfit":
        return "NON_PROFIT_CORP";

      case "firstLookOwnerOccupied":
        return "FL_OWNER_OCCUPIED_BUYER";

      case "firstLookNonProfit":
        return "FL_QL_NON_PROFIT_CORP";

      case "caBillLandTrust":
        return "COMMUNITY_LAND_TRUST";

      case "caBillHousingCoop":
        return "LTD_EQUITY_HOUSING_CO";

      case "caBillCaliforniaState":
        return "STATE_OF_CA";
    }
  };

  const getBuyerCategoryName = () => {
    switch (primaryEntityType) {
      case "selfOccupancy":
        return primaryBuyerData.selfOccupancyName;

      case "hudNonProfit":
        return primaryBuyerData.hudNonProfitName;

      case "government":
        return primaryBuyerData.governmentName;

      case "caBillOwnerOccupied":
        return primaryBuyerData.caBillOwnerOccupiedName;

      case "caBillNonProfit":
        return primaryBuyerData.caBillNonProfitName;

      case "caBillLandTrust":
        return primaryBuyerData.caBillLandTrustName;

      case "caBillHousingCoop":
        return primaryBuyerData.caBillHousingCoopName;

      case "caBillCaliforniaState":
        return primaryBuyerData.caBillCaliforniaStateName;
    }
  };

  const getDocList = () => {
    const pofFiles = uploadedFiles.pofFiles;
    const buyerSelfCWCOTFiles = uploadedFiles.buyerSelfCWCOTFiles;
    const buyerLLCFiles = uploadedFiles.buyerLLCFiles;
    const caBillCommunityTrustlandFiles =
      uploadedFiles.caBillCommunityTrustlandFiles;
    const caBillEquHousingCoFiles = uploadedFiles.caBillEquHousingCoFiles;
    const caBillNonProfitCorpFiles = uploadedFiles.caBillNonProfitCorpFiles;
    const caBillOwnerOccupiedFiles = uploadedFiles.caBillOwnerOccupiedFiles;
    const caBillStateofCalifornia = uploadedFiles.caBillStateofCalifornia;
    const caBuyerCommunityTrustLandCWCOTFiles =
      uploadedFiles.caBuyerCommunityTrustLandCWCOTFiles;
    const caBuyerGovtCWCOTFiles = uploadedFiles.caBuyerGovtCWCOTFiles;
    const caBuyerLimEquHousingCooCWCOTFiles =
      uploadedFiles.caBuyerLimEquHousingCooCWCOTFiles;
    const caBuyerNonProfitCorpCWCOTFiles =
      uploadedFiles.caBuyerNonProfitCorpCWCOTFiles;
    const caBuyerOwnerOccupiedCWCOTFiles =
      uploadedFiles.caBuyerOwnerOccupiedCWCOTFiles;

    const caBuyerStateOfClaiforniaCWCOTFiles =
      uploadedFiles.caBuyerStateOfClaiforniaCWCOTFiles;
    const coBuyerLLCFiles = uploadedFiles.coBuyerLLCFiles;

    const allUploadedFiles = [
      pofFiles,
      buyerSelfCWCOTFiles,
      buyerLLCFiles,
      caBillCommunityTrustlandFiles,
      caBillEquHousingCoFiles,
      caBillNonProfitCorpFiles,
      caBillOwnerOccupiedFiles,
      caBillStateofCalifornia,
      caBuyerCommunityTrustLandCWCOTFiles,
      caBuyerGovtCWCOTFiles,
      caBuyerLimEquHousingCooCWCOTFiles,
      caBuyerNonProfitCorpCWCOTFiles,
      caBuyerOwnerOccupiedCWCOTFiles,
      caBuyerStateOfClaiforniaCWCOTFiles,
      coBuyerLLCFiles,
    ];

    // Filter out only those arrays that have data
    const nonEmptyUploadedFiles = allUploadedFiles.filter(
      (fileArray) => Array.isArray(fileArray) && fileArray.length > 0
    );

    // Optionally flatten if you want a single-level array of all files
    const allFilesFlat = nonEmptyUploadedFiles.flat();

    return allFilesFlat;
  };

  const handleFinalSubmit = async () => {
    try {
      setIsSubmitting(true);

      // Base payload structure
      const payload = {
        agentFlag: selectedDescription === "Agent" ? "Y" : "N",
        representedByAgent:
          (selectedDescription === "Buyer" && buyingForSelf === "Yes") ||
            (selectedDescription === "Agent" && buyingForSelf === "No")
            ? "Y"
            : "N",

        buyer: {
          firstName: primaryBuyerData.firstName,
          lastName: primaryBuyerData.lastName,
          middleInitials: primaryBuyerData.middleInitials || "",
          buyerCategory: getBuyerCategory(),
          address1: primaryBuyerData.address1,
          city: primaryBuyerData.city,
          zip: primaryBuyerData.zip,
          email: primaryBuyerData.email,
          phone: primaryBuyerData.phone,
          stateId: primaryBuyerData.stateId,
          buyerCategoryName: getBuyerCategoryName(),
        },
        agent: {
          firstName: agentData.firstName || "",
          lastName: agentData.lastName || "",
          middleInitials: agentData.middleInitials || "",
          companyName: agentData.agencyName || "",
          email: agentData.email || "",
          phone: agentData.phone || "",
          address1: agentData.address1 || "",
          address2: agentData.address2 || "",
          city: agentData.city || "",
          stateId: agentData.stateId || "",
          zip: agentData.zip || "",
          corpLicenceState: agentData.corporateLicenseState || "",
          corpLicenceNumber: agentData.corporateLicenseNumber || "",
          licenceState: agentData.individualLicenseState || "",
          licenceNumber: agentData.individualLicenseNumber || "",
          licenceExpiryDate: agentData.licenseExpiryDate || "",
        },
        // templateName: profileName,
        // templateId: selectedProfile?.templateId || "",
        newTemplate: "Y",
        updateFiles:
          uploadedFiles.primaryBuyer?.length > 0 ||
            uploadedFiles.pof?.length > 0
            ? "Y"
            : "N",
        listingId: listingId,
        userId: formState.profileDetails?.userDetails?.userId,
        documentIds: [],
        variationNumber: "v2",
        propertyStatus: "",
        cifId: cifId,
        cwcotUpdateEnabled: cifData?.data?.cwcotUpdateEnabled,
        cwcotUpdateValid: cifData?.data?.cwcotUpdateValid,
        isStateWorkflowDurationActive: cifData?.data?.isStateWorkflowDurationActive || "N",
        isStateWorkflowEnabled: cifData?.data?.isStateWorkflowEnabled,
        // First Look (SPS 945) flags
        firstLook: cifData?.data?.firstLook,
        firstLookExpiryDate: cifData?.data?.firstLookExpiryDate,
      };

      if (selectedClosingOption === "BUYER_PAYS") {
        payload.closingInfoChoice = "BuyerChosen";
      }
      if (selectedClosingOption === "SELLER_PAYS") {
        payload.closingInfoChoice = "SellerChosen";
      }

      if (isClosingAgentRequired && selectedClosingOption === "BUYER_PAYS") {
        payload.closingAgent = {
          firstName: closingAgentForm.name,
          company: closingAgentForm.company,
          address1: closingAgentForm.address1,
          address2: closingAgentForm.address2,
          city: closingAgentForm.city,
          zip: closingAgentForm.zip,
          email: closingAgentForm.email,
          phone: closingAgentForm.phone,
          stateId: closingAgentForm.state,
        };
      }

      if (
        isTitleInsuranceProviderRequired &&
        selectedClosingOption === "BUYER_PAYS"
      ) {
        payload.titleProvider = {
          firstName: titleInsuranceForm.name,
          company: titleInsuranceForm.company,
          address1: titleInsuranceForm.address1,
          address2: titleInsuranceForm.address2,
          city: titleInsuranceForm.city,
          zip: titleInsuranceForm.zip,
          email: titleInsuranceForm.email,
          phone: titleInsuranceForm.phone,
          stateId: titleInsuranceForm.state,
        };
      }
      // Non-CWCOT logic
      if (primaryEntityType === "business") {
        payload.buyer.companyName = primaryBuyerData.companyName;
      }

      // Initialize documentIds array with primary buyer documents

      console.log("getDocList() -> ", getDocList());
      if (getDocList().length > 0) {
        payload.documentIds = getDocList().map((file) => file?.documentId);
      }

      // Add POF documents if they exist
      if (uploadedFiles.pof?.length > 0) {
        payload.documentIds = [
          ...payload.documentIds,
          ...uploadedFiles.pof.map((file) => file.documentId),
        ];
      }

      // Add co-buyer data if exists
      if (hasCobuyer === "yes") {
        payload.coBuyer = {
          firstName: cobuyerData.firstName,
          lastName: cobuyerData.lastName,
          middleInitials: cobuyerData.middleInitials || "",
          address1: cobuyerData.address1,
          city: cobuyerData.city,
          zip: cobuyerData.zip,
          email: cobuyerData.email,
          phone: cobuyerData.phone,
          stateId: cobuyerData.stateId,
        };

        if (cobuyerEntityType === "business") {
          payload.coBuyer.companyName = cobuyerData.companyName;
        }

        // Add co-buyer documents if they exist
        if (uploadedFiles.coBuyer?.length > 0) {
          payload.documentIds = [
            ...payload.documentIds,
            ...uploadedFiles.coBuyer.map((file) => file.documentId),
          ];
        }
      }

      console.log("Submitting payload:", payload);
      const response = await saveCif(payload);

      console.log("response -> ", response);

      if (response?.data?.status === "SUCCESS") {
        if (paymentFlag) {
          setCifCompleted(false);
          const payload = {
            bidAmount: 0,
            bidType: "PLACE_BID",
            buyerEmail: paymentFlag ? winningBidUserEmail : null,
            listingId: listingId || "0001744009899421AUCN2",
          };
          const bidDepositResponse = await getBidDepositDetail(payload);
          dispatch(setBidAmount(bidDepositResponse?.data?.data));
          if (bidDepositResponse?.data?.data?.bidDepositRequired === true) {
            setIsBidDeposit(true);
          }
        } else {
          setCifCompleted(true);
          window.scrollTo(0, 0);
        }
      } else {
        throw new Error(
          response?.data?.errorMessage || "Failed to save purchase profile"
        );
      }
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      {" "}
      <div className="accordion-item pof-accordion">
        <h2 className="accordion-header">
          <button
            className={`accordion-button ${collapseAccordian === 4 ? "" : "collapsed"
              }`}
            type="button"
            onClick={(e) => e.preventDefault()}
            aria-expanded={collapseAccordian === 4}
          >
            <div className="d-flex align-items-center justify-content-between w-100">
              <div className="d-flex align-items-center">
                {/* Show black icon by default, green only if submitted */}
                {submittedAccordions?.includes(4) && collapseAccordian !== 4 ? (
                  <BsCheckCircleFill className="icon_bid me-2" size={30} />
                ) : (
                  <BsCheckCircleFill className="text-dark me-2" size={30} />
                )}
                <span className="bid_font_cif ">
                  {" "}
                  Proof of Funds/ Pre-Approval Letter
                </span>
              </div>
            </div>
          </button>
        </h2>
        <div
          className={`accordion-collapse collapse ${collapseAccordian === 5 ? "show" : ""
            }`}
          data-bs-parent="#accordionFlushExample"
        >
          {isEnabled && (
            <div className="accordion-body">
              <p className=" ack-poff">
                To provide the seller with the necessary information to evaluate
                your bid, please upload the following supporting documentation.
                For cash purchases, please attach a bank statement, investment
                account statement, or similar document to verify adequate funds
                to close. For financed purchases, please attach a copy of a
                pre-approval letter from your selected financial institution.
                Please note that the buyer's name and the name on the proof of
                funds, or pre-approval letter, need to match in order for the
                seller to consider it.
              </p>
              <div className="buyer-form">
                <Row>
                  <Form.Group
                    as={Col}
                    className="mb-3 d-flex align-items-center justify-content-center flex-column p-5"
                    style={{ border: "2px dotted #C5E3FF" }}
                  >
                    <div className="">
                      <div className="pof_pof pb20">Upload Proof of Funds</div>
                      {pof === "Required" && (
                        <span className="text-danger"></span>
                      )}
                      <button
                        className="continueCTA ml40 w210"
                        onClick={() => pofFileInputRef.current?.click()}
                        disabled={isUploadingPOF || isDeletingPOF}
                      >
                        {isUploadingPOF ? "Uploading..." : "Browse"}
                      </button>

                      <input
                        type="file"
                        ref={pofFileInputRef}
                        multiple
                        style={{ display: "none" }}
                        accept=".pdf, .jpg, .jpeg"
                        onChange={handlePOFFileChange}
                      />
                    </div>
                  </Form.Group>
                  <p className="cifTxt">
                    File formats accepted: pdf, jpg and jpeg. Maximum file size
                    allowed is 10MB.
                    {/* {pof === "Required" && (
                      <span className="text-danger ms-2">
                        (Document upload is required)
                      </span>
                    )} */}
                  </p>

                  {/* Upload Status Shimmer */}
                  {(isUploadingPOF || isDeletingPOF) && (
                    <div style={{ width: "100%", marginTop: "10px" }}>
                      <ShimmerTitle line={2} gap={10} variant="primary" />
                    </div>
                  )}

                  {/* POF File Details */}
                  {/* {!isUploadingPOF && !isDeletingPOF && uploadedFiles.pof && (
                    <div
                      className="mt-2 d-flex align-items-center justify-content-between"
                      style={{
                        border: "1px solid #D3EAFF",
                        padding: "8px 12px",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                      }}
                    >
                      <small
                        style={{
                          wordBreak: "break-all",
                          marginRight: "16px",
                        }}
                      >
                        {uploadedFiles.pof.fileName}
                      </small>
                      <Button
                        variant="link"
                        onClick={handlePOFFileDelete}
                        disabled={isDeletingPOF || isUploadingPOF}
                        style={{
                          textDecoration: "none",
                          color: "#dc3545",
                          padding: "0",
                          marginLeft: "16px",
                        }}
                      >
                        <i className="fas fa-times"></i> Remove
                      </Button>
                    </div>
                  )} */}
                  {/* POF File Details */}
                  {!isUploadingPOF &&
                    !isDeletingPOF &&
                    uploadedFiles.pof?.map((file, index) => (
                      <div
                        key={index}
                        className="mt-2 d-flex align-items-center justify-content-between"
                        style={{
                          border: "1px solid #D3EAFF",
                          padding: "8px 12px",
                          borderRadius: "4px",
                          backgroundColor: "#fff",
                          width: "80%",
                        }}
                      >
                        <small
                          style={{
                            wordBreak: "break-all",
                            marginRight: "16px",
                            color: "#208EF0", // Added this
                            fontSize: "16px",
                            fontFamily: "graphikmedium",
                          }}
                        >
                          {file.fileName}
                        </small>
                        <Button
                          variant="link"
                          onClick={() => handlePOFFileDelete(index)}
                          disabled={isDeletingPOF || isUploadingPOF}
                          style={{
                            textDecoration: "none",
                            color: "#f25d49",
                            padding: "0",
                            marginLeft: "16px",
                            fontSize: "16px",
                            fontFamily: "graphikmedium",
                          }}
                        >
                          <i className="fas fa-times"></i> Remove
                        </Button>
                      </div>
                    ))}

                  {/* Error Message */}
                  {fileError && (
                    <div className=" mt-2">
                      <p className="text-danger-bidd">{fileError}</p>
                    </div>
                  )}
                  {/* Acknowledgment and Submit Section */}
                  <div className="mt-4">
                    <div className="form-check mb-3">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="pof-acknowledgement"
                        checked={acknowledgement}
                        onChange={handleAcknowledgementChange}
                      />
                      <label
                        className="form-check-label ms-2 ack-poff"
                        htmlFor="pof-acknowledgement"
                      >
                        I hereby acknowledge that the information provided in
                        this contact Information form is complete and accurate.
                        I understand that such information will be used to
                        prepare the transaction documents for the purchase of
                        the property if my bid is selected by the seller to
                        proceed with the transaction.
                      </label>
                    </div>
                    {/* Acknowledgement Error Message */}
                    {/* Acknowledgement Error Message */}
                    {hasCheckboxInteracted && acknowledgementError && (
                      <div className="text-danger-bidd mb-3">
                        <small>{acknowledgementError}</small>
                      </div>
                    )}

                    {/* Submit Button - Always visible but disabled based on acknowledgement */}
                    <button
                      type="button"
                      className="continueCTA"
                      onClick={handlePOFSubmit}
                      disabled={
                        !acknowledgement || isUploadingPOF || isDeletingPOF
                      }
                      style={!acknowledgement ? {
                        opacity: 0.65,
                        cursor: 'not-allowed',
                        backgroundColor: '#b1c3d8',
                        borderColor: '#b1c3d8'
                      } : {}}
                    >
                      {isUploadingPOF ? (
                        <span>
                          <span className="spinner-border spinner-border-sm me-2" />
                          Processing...
                        </span>
                      ) : paymentFlag ? (
                        "Continue"
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </Row>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditProofOfFunds;
